/* eslint-disable react/jsx-props-no-spreading */
import { ErrorBoundary } from 'react-error-boundary'
import { QueryErrorResetBoundary } from 'react-query'

import { ErrorTryAgain } from '../ErrorTryAgain/ErrorTryAgain'

const ResetErrorBoundaryButton = ({
  resetErrorBoundary,
}: {
  resetErrorBoundary: () => void
}) => <ErrorTryAgain onTryAgain={resetErrorBoundary} center />

/** Compose an error boundary for react-query. */
export const TryAgainErrorBoundary = ({
  children,
}: {
  children: React.ReactNode
}) => (
  <QueryErrorResetBoundary>
    {({ reset }) => (
      <ErrorBoundary onReset={reset} fallbackRender={ResetErrorBoundaryButton}>
        {children}
      </ErrorBoundary>
    )}
  </QueryErrorResetBoundary>
)

/** High-order component for `TryAgainErrorBoundary`. */
export const withTryAgainErrorBoundary = <P,>(
  Component: React.ComponentType<P>
): React.ComponentType<P> => {
  const Wrapped: React.ComponentType<P> = (props: P) => (
    <TryAgainErrorBoundary>
      <Component {...props} />
    </TryAgainErrorBoundary>
  )

  // format for display in DevTools
  const name = Component.displayName || Component.name || 'Unknown'
  Wrapped.displayName = `withErrorBoundary(${name})`

  return Wrapped
}
